// extracted by mini-css-extract-plugin
module.exports = {"player":"Video_player__yu3gI"};